import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CustomLoader from '../common/CustomLoader';
import ParentDocCard from '../common/ParentDocCard';
import { checkTabName, tabs } from '../../common/utils/api_utils';
import EditProjectConstant from './EditProjectConstant';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ConstantForm from '../common/ConstantForm';
import { appConstantText } from '../../common/docs/content';
import AppConstants from './AppConstants';
import EnvironmentConstants from './environments/EnvironmentConstants';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';

import { APP_CONSTANT, ENV_VARIABLE } from 'drapcode-constant';
export class DefaultPage extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
  };

  state = {
    activeTab: 'appConstant',
    currentConstantId: '',
  };

  toggle = (activeTab) => {
    this.setState({ activeTab: activeTab });
  };
  componentDidMount() {
    const { match, actions, location } = this.props;
    const { projectId, version } = match.params;
    actions.getPermissionFlags({ projectId });
    actions.loadProjectDetailAppSetting({ projectId, version });    
    
    if (location) {
      const { state: locationState, pathname: pathName } = location;
      const { activeTab: locationActiveTab } = locationState ? locationState : '';
      if (locationActiveTab) {
        this.toggle(locationActiveTab);
      } else {
        if (tabs.some((tab) => pathName.endsWith(tab))) {
          let tabName = checkTabName(pathName);
          if (tabName) this.toggle(tabName);
        }
      }
    }
  }

  handleSubmit = (values) => {
    const { match, actions, location } = this.props;
    const { projectId, version } = match.params;
    actions.addProjectConstant({
      projectId,
      version,
      data: values,
    });
  };

  updateCurrentConstantId = (id) => {
    this.setState({ currentConstantId: id });
  };

  handleConstantSubmit = (values) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions
      .updateProjectConstant({
        projectId,
        version,
        constantId: this.state.currentConstantId,
        data: values,
      })
      .then(() => {
        this.setState({ currentConstantId: '' });
        this.toggle('appConstant');
        actions.loadProjectDetailAppSetting({ projectId, version });
      });
  };

  showConstantUpdateForm = () => {
    const { appSetting } = this.props;
    const { updateProjectConstantPending } = appSetting;
    const { projectDetail } = appSetting;
    if (projectDetail) {
      let { constants } = projectDetail;
      constants = constants || [];
      const currentProjectConstant = constants.find((e) => e.uuid === this.state.currentConstantId);
      return currentProjectConstant ? (
        <ConstantForm
          constantType={currentProjectConstant.constantType}
          constant={currentProjectConstant}
          handleSubmit={this.handleConstantSubmit}
          isCollection={false}
          showDerivedConstantLoader={updateProjectConstantPending}
          cancelToggle={true}
          toggle={this.toggle}
        />
      ) : (
        'Not found'
      );
    }
  };

  render() {
    const { match, appSetting, actions } = this.props;
    const { projectId, version } = match.params;
    const { activeTab } = this.state;
    const {
      addProjectConstantPending,
      loadProjectDetailAppSettingPending,
      createCollectionConstantPending,
      updateConstantOfCollectionPending,
      projectDetail,
      permissionFlags,
    } = appSetting;

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    if (loadProjectDetailAppSettingPending || !projectDetail) {
      return (
        <CommonPageComponent parentClassName="">
          <div className="row mx-auto">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
              <CustomLoader
                loading={loadProjectDetailAppSettingPending}
                size="20px"
                color="#303453"
              />
            </div>
          </div>
        </CommonPageComponent>
      );
    }
    const showDerivedConstantLoader =
      createCollectionConstantPending ||
      updateConstantOfCollectionPending ||
      addProjectConstantPending;
    const { constants, environments } = projectDetail;
    return (
      <CommonPageComponent containerClassName="appSetting">
        <AppSettingsNav activeTab={activeTab} projectDetail={projectDetail} />
        <div className="tab-content w-100">
          {activeTab === 'appConstant' && (
            <div className={`tab-pane ${activeTab === 'appConstant' && 'active'}`} id="appConstant">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                <EnvironmentConstants
                  projectId={projectId}
                  version={version}
                  environments={environments}
                  toggle={this.toggle}
                  actions={actions}
                  appSetting={appSetting}
                  deleteFlag={permissionsArray.includes(ENV_VARIABLE)}
                />
                <AppConstants
                  projectId={projectId}
                  constants={constants}
                  handleDelete={this.handleDelete}
                  handleSubmit={this.handleSubmit}
                  toggle={this.toggle}
                  showDerivedConstantLoader={showDerivedConstantLoader}
                  updateCurrentConstantId={this.updateCurrentConstantId}
                  deleteFlag={permissionsArray.includes(APP_CONSTANT)}
                />
              </div>
              <ParentDocCard>
                <h5>
                  <b>About App Constant</b>
                </h5>
                <p>{appConstantText}</p>
                <br />
              </ParentDocCard>
            </div>
          )}
          <div
            className={`tab-pane ${activeTab === 'editAppConstant' && 'active'}`}
            id="editAppConstant"
          >
            <EditProjectConstant
              showConstantUpdateForm={this.showConstantUpdateForm}
              projectId={projectId}
              version={version}
              toggle={this.toggle}
            />
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
    home: state.home,
    externalApis: state.externalapi.externalApis,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
